/**
 * Color utility functions and palettes for analytics components
 * These could be made configurable via API or user preferences in the future
 */

// Primary color palette for charts and visualizations
export const ANALYTICS_COLOR_PALETTE = [
  '#4CAF50', // Green
  '#2196F3', // Blue
  '#FF9800', // Orange
  '#9C27B0', // Purple
  '#F44336', // Red
  '#00BCD4', // Cyan
  '#FFEB3B', // Yellow
  '#795548', // Brown
  '#607D8B', // Blue Grey
  '#E91E63', // Pink
  '#8BC34A', // Light Green
  '#3F51B5'  // Indigo
];

// State-specific color mappings for consistency across components
export const STATE_COLORS = {
  intro: '#00BCD4',
  setup: '#4CAF50',
  tutorial: '#9C27B0',
  firstturn: '#F44336',
  teaching: '#2196F3',
  gameplay: '#FF9800',
  scoring: '#8BC34A',
  winner_announced: '#FFD700'
};

// Enhanced color palette with transparency variants
export const CHART_COLORS = {
  background: ANALYTICS_COLOR_PALETTE.map(color => color + '80'), // 50% opacity
  border: ANALYTICS_COLOR_PALETTE,
  hover: ANALYTICS_COLOR_PALETTE.map(color => color + 'CC') // 80% opacity
};

/**
 * Get a color from the analytics palette by index
 * @param {number} index - The index in the color palette
 * @returns {string} - The hex color code
 */
export const getAnalyticsColor = (index) => {
  return ANALYTICS_COLOR_PALETTE[index % ANALYTICS_COLOR_PALETTE.length];
};

/**
 * Get a state-specific color
 * @param {string} stateKey - The state key (e.g., 'intro', 'setup')
 * @returns {string} - The hex color code
 */
export const getStateColor = (stateKey) => {
  return STATE_COLORS[stateKey] || ANALYTICS_COLOR_PALETTE[0];
};

/**
 * Generate color arrays for Chart.js datasets
 * @param {number} count - Number of colors needed
 * @param {number} opacity - Opacity level (0-1)
 * @returns {Object} - Object with background and border color arrays
 */
export const generateChartColors = (count, opacity = 0.8) => {
  const colors = [];
  for (let i = 0; i < count; i++) {
    colors.push(getAnalyticsColor(i));
  }
  
  return {
    backgroundColor: colors.map(color => color + Math.round(opacity * 255).toString(16).padStart(2, '0')),
    borderColor: colors,
    hoverBackgroundColor: colors.map(color => color + 'CC'),
    hoverBorderColor: colors
  };
};
